import PublicLayout from "@/components/Common/Containers/PublicLayout";
import React from "react";
import ForgotPasswordForm from "../../Common/Forms/ForgotPasswordForm";

const ForgotPassword: React.FC = () => {
  return (
    <>
      <PublicLayout>
        <div className="flex-grow  h-full flex items-center justify-center px-4 md:bg-gradient-to-b from-custom-blue to-custom-purple">
          <div className="w-full max-w-4xl flex flex-col md:flex-row">
            <div className="hidden order-last md:order-first w-full md:w-1/2 pr-8 md:flex flex-col justify-center">
              <h2 className="text-xl md:text-2xl mb-4">
                Sootchy® education program
              </h2>
              <ul className="space-y-2">
                <li className="flex items-center py-2">
                  <svg
                    className="w-5 h-5 text-green-500 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  Tax-free growth
                </li>
                <li className="flex items-center py-2">
                  <svg
                    className="w-5 h-5 text-green-500 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  Your employer will match your contributions
                </li>
                <li className="flex items-center py-2">
                  <svg
                    className="w-5 h-5 text-green-500 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  Automatic & easy to set-up
                </li>
              </ul>
            </div>
            {/** form */}
            <ForgotPasswordForm />
          </div>
        </div>
      </PublicLayout>
    </>
  );
};

export default ForgotPassword;
